import axios from 'axios';

// Set the base URL for your API
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Set up a request interceptor to include the JWT token in the Authorization header
axios.interceptors.request.use(
  (config) => {
    // Check if the request is not for the sign-in endpoint
    if (config.url !== '/api/auth/signin') {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
